export default "__VITE_ASSET__7b7a248d__"